<template>
  <Page class="page-title">
    <div class="page-title-header">
      <div @click="$emit('back')" class="icon icon-dc_phone_arrow_return"></div>
      <div @click="$emit('title')" class="title">{{title}}</div>
      <div @click="$emit('commit')" class="save">{{lang.commit}}</div>
    </div>
    <slot></slot>
  </Page>
</template>

<script>
import Page from './Page.vue'
export default {
  components: { Page },
  props: {
    title: {
      type: String
    },
    lang: {
      type: Object,
      default () {
        return {
          commit: '保存'
        }
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.page-title {
  & .page-title-header {
    border-bottom: 1px solid var(--colorDisabled);
    @media (--mediaPc) {
      height: 88px;
    }
    @media (--mediaMobile) {
      height: calc(88px / var(--scaleMobile));
    }
    & .icon {
      position: absolute;
      top: 0;
      left: 0;
      @media (--mediaPc) {
        padding: 30px;
      }
      @media (--mediaMobile) {
        padding: calc(30px / var(--scaleMobile));
      }
    }
    & .title {
      text-align: center;
      font-weight: normal;
      @media (--mediaPc) {
        padding-top: 28px;
        font-size: var(--textSize1);
      }
      @media (--mediaMobile) {
        padding-top: calc(28px / var(--scaleMobile));
        font-size: var(--textSize1Mobile);
      }
    }
    & .save {
      position: absolute;
      top: 0;
      right: 0;
      @media (--mediaPc) {
        padding: 30px;
        font-size: var(--textSize3);
      }
      @media (--mediaMobile) {
        padding: calc(30px / var(--scaleMobile));
        font-size: var(--textSize3Mobile);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/TitlePage.vue